import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

const HelpAndSupportSkeleton: React.FC = () => {
  return (
    <div className="w-full space-y-8">
      {/* Hero Skeleton - Sincronizado com HelpAndSupport.tsx */}
      <div className="rounded-[2.5rem] p-10 sm:p-14 bg-gray-100 shadow-xl relative overflow-hidden animate-pulse">
        <div className="relative z-10 max-w-2xl space-y-4">
          <Skeleton
            variant="text"
            width={400}
            height={32}
            className="rounded-lg opacity-40 bg-gray-300"
          />
          <Skeleton
            variant="text"
            width={500}
            height={48}
            className="rounded-lg opacity-20 bg-gray-300"
          />
        </div>
      </div>

      {/* Contact Cards Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-stretch">
        {[1, 2].map((i) => (
          <Card
            key={i}
            className="bg-white/50 border-purple-50/50 p-6 space-y-4 rounded-3xl"
          >
            <div className="w-12 h-12 rounded-full bg-gray-100" />
            <Skeleton variant="text" width={180} height={20} className="mb-2" />
            <div className="space-y-1">
              <Skeleton variant="text" width="90%" height={14} />
              <Skeleton variant="text" width="85%" height={14} />
            </div>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={48}
              className="rounded-2xl mt-4"
            />
          </Card>
        ))}
      </div>

      {/* FAQ List Skeleton */}
      <div className="pt-4 space-y-6">
        <Skeleton
          variant="text"
          width={220}
          height={24}
          className="mb-6 opacity-30"
        />
        <div className="space-y-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="border border-purple-50 rounded-2xl p-5 flex items-center justify-between"
            >
              <Skeleton
                variant="text"
                width="70%"
                height={16}
                className="opacity-40"
              />
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                className="rounded-full opacity-30"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HelpAndSupportSkeleton;
